'use strict';
import GraphViewSet from './GraphViewSet';
import {
    move,
    loop,
    tweenColor,
    setNodeVisible,
    moveCamera,
    formatDay,
    formatDate,
    setValueWithAnimation,
    hideNodeWithAll,
    showNodeWithAll,
    numBetween,
    randomNumber,
    showPanel,
    hidePanel,
    panelAnim
} from '../util/util';

import Easing from "../util/Easing";

export default class App {
    constructor() {
        // 二维拓扑视图
        this.g2d = new ht.graph.GraphView();
        this.g2dDm = this.g2d.dm();

        // 三维拓扑视图
        this.g3d = new ht.graph3d.Graph3dView();
        this.g3dDm = this.g3d.dm();

        let view = this.g2d.getView();
        // 设置 View 的样式
        GraphViewSet.styleSetting(view);
        // GraphView 的一般操作设置
        GraphViewSet.commonSetting(this.g2d);
        // 避免 2D 和 3D 的交互重叠
        GraphViewSet.interaction2D3D(this.g2d);

        // this.g3d.getView().updateAppendMatrix = true ;

        // this.g3d.getView().appendChild(view);
        this.g2d.addToDOM(this.g3d.getView());

        this.g3d.getHighlightHelper().mode = 0;
        // this.g3d.enablePostProcessing('Fxaa', true);

        // 修改左右键交互方式
        let mapInteractor = new ht.graph3d.MapInteractor(this.g3d);
        this.g3d.setInteractors([mapInteractor]);
        mapInteractor.maxPhi = Math.PI / 2;

        window.g2d = this.g2d;
        window.g3d = this.g3d;

        this.roamAnim = null;

        const G = {};
        window.G = G;
        // 事件派发
        G.event = new ht.Notifier();

        // 初始化场景
        this.init();
    }

    /**
     * @description 初始化场景
     * @memberof App
     */
    init() {
        this.load3D();
        // this.g2d.showDebugTip();
        this.load2D();
        this.loaded3DHandler();
    }

    /**
     * @description 二维场景的加载
     * @memberof App
     */
    load2D() {
        const self = this;
        const g2d = self.g2d;
        const g2dDm = g2d.dm();
        // ht.Default.xhrLoad('displays/-ing/智能楼宇/demo.json', (json) => {
        ht.Default.xhrLoad('displays/demo.json', (json) => {
            if (!json) return;
            g2dDm.deserialize(json);

            // 按钮初始化
            this.intelligentBuildingButton = g2dDm.getDataByTag('intelligentBuildingButton');
            this.coolingCentralStationButton = g2dDm.getDataByTag('coolingCentralStationButton');
            this.heatingCentralStationButton = g2dDm.getDataByTag('heatingCentralStationButton');
            this.floorNavigationButton = g2dDm.getDataByTag('floorNavigationButton');
            this.parkingButton = g2dDm.getDataByTag('parkingButton');
            this.elevatorButton = g2dDm.getDataByTag('elevatorButton');
            this.logo = g2dDm.getDataByTag('logo');
            this.intelligentMonitoring = g2dDm.getDataByTag('intelligentMonitoring');
            this.close = g2dDm.getDataByTag('close');
            this.video = g2dDm.getDataByTag('video');

            let tittle = this.tittle = g2dDm.getDataByTag('tittle');
            let tittleName = this.tittleName = g2dDm.getDataByTag('tittleName');
            let scale = this.scale = g2dDm.getDataByTag('scale');
            let left = this.left = g2dDm.getDataByTag('left');
            let right = this.right = g2dDm.getDataByTag('right');

            this.dataStatisticsPanel = g2dDm.getDataByTag('dataStatisticsPanel');
            this.dataStatisticsPanelContent = g2dDm.getDataByTag('dataStatisticsPanelContent');

            this.weatherPanel = g2dDm.getDataByTag('weatherPanel');
            this.weatherPanelContent = g2dDm.getDataByTag('weatherPanelContent');

            this.coldStation_realTimePanel = g2dDm.getDataByTag('coldStation_realTimePanel');
            this.coldStation_realTimePanelContent = g2dDm.getDataByTag('coldStation_realTimePanelContent');

            this.monitoringPanel = g2dDm.getDataByTag('monitoringPanel');
            this.monitoringPanelContent = g2dDm.getDataByTag('monitoringPanelContent');

            this.coldStation_efficiencyIndexPanel = g2dDm.getDataByTag('coldStation_efficiencyIndexPanel');
            this.coldStation_efficiencyIndexPanelContent = g2dDm.getDataByTag('coldStation_efficiencyIndexPanelContent');

            this.coldStation_hostRunningDataPanel = g2dDm.getDataByTag('coldStation_hostRunningDataPanel');
            this.coldStation_hostRunningDataPanelContent = g2dDm.getDataByTag('coldStation_hostRunningDataPanelContent');

            this.button = g2dDm.getDataByTag('button');

            this.hotStation_realTimePanel = g2dDm.getDataByTag('hotStation_realTimePanel');
            this.hotStation_realTimePanelContent = g2dDm.getDataByTag('hotStation_realTimePanelContent');

            this.hotStation_efficiencyIndexPanel = g2dDm.getDataByTag('hotStation_efficiencyIndexPanel');
            this.hotStation_efficiencyIndexPanelContent = g2dDm.getDataByTag('hotStation_efficiencyIndexPanelContent');

            this.hotStation_hostRunningDataPanel = g2dDm.getDataByTag('hotStation_hostRunningDataPanel');
            this.hotStation_hostRunningDataPanelContent = g2dDm.getDataByTag('hotStation_hostRunningDataPanelContent');
            this.roamButton = g2dDm.getDataByTag('roamButton');
            let nowDate = g2dDm.getDataByTag('nowDate');
            let nowTime = g2dDm.getDataByTag('nowTime');
            let nowWeek = g2dDm.getDataByTag('nowWeek');

            // 时间调度器
            let intervalTimer = {
                duration: 1000,
                easing: t => t,
                action: (data) => {
                    let date = new Date();
                    if (data === nowDate) {
                        nowDate.s('text', formatDate(date, 'YYYY-MM-DD'));
                    }
                    if (data === nowTime) {
                        nowTime.s('text', formatDate(date, 'hh:mm:ss'))
                    }
                    if (data === nowWeek) {
                        nowWeek.s('text', formatDate(date, '星期w'))
                    }
                }
            };
            g2dDm.addScheduleTask(intervalTimer);

            // 冷站光圈调度动画
            this.coldStationPanelIntervalTimer2 = {
                duration: 1000,
                easing: t => t,
                action: (data) => {
                    if (data._displayName === '冷站光圈') {
                        let rotation = data.getRotation();
                        data.setRotation(rotation + (Math.PI / 100));
                    }
                }
            };

            // 热站光圈调度动画
            this.hotStationPanelIntervalTimer2 = {
                duration: 1000,
                easing: t => t,
                action: (data) => {
                    if (data._displayName === '热站光圈') {
                        let rotation = data.getRotation();
                        data.setRotation(rotation + (Math.PI / 100));
                    }
                }
            };

            // 面板动画入口
            this.tittleAnim();
            this.panelTime();

            // 2D图纸加载完后执行事件处理
            this.loaded2DHandler();
        });
    }

    // 标题动画
    tittleAnim() {
        const self = this;
        const g2d = self.g2d;
        const g2dDm = g2d.dm();

        let tittle_index = this.tittle.getScaleX();
        let scale_index = this.scale.s('clip.percentage');
        let left_index = this.left.s('clip.percentage');
        let right_index = this.right.s('clip.percentage');

        ht.Default.startAnim({
            duration: 1000,
            easing: Easing.swing,
            action: (v, t) => {
                this.tittle.setScaleX(tittle_index + (1 - tittle_index) * v);
            },
            finishFunc: () => {
                // this.tittleName.s('2d.visible', true);
                ht.Default.startAnim({
                    duration: 1000,
                    easing: Easing.swing,
                    action: (v, t) => {
                        this.tittleName.eachChild(c => {
                            c.s('opacity', c.s('opacity') + (1 - c.s('opacity')) * v);
                        });
                        this.scale.s('clip.percentage', scale_index + (1 - scale_index) * v);
                        this.left.s('clip.percentage', left_index + (1 - left_index) * v);
                        this.right.s('clip.percentage', right_index + (1 - right_index) * v);
                    },
                    finishFunc: () => {
                        // this.dataStatisticsPanelAnim();
                        // this.coldStationEfficiencyIndexPanelAnim();
                        panelAnim(this.dataStatisticsPanel, this.dataStatisticsPanelContent);
                        panelAnim(this.coldStation_efficiencyIndexPanel, this.coldStation_efficiencyIndexPanelContent);
                        ht.Default.startAnim({
                            duration: 400,
                            easing: t => t,
                            action: () => {
                            },
                            finishFunc: () => {
                                // this.weatherPanelAnim();
                                // 天气面板
                                panelAnim(this.weatherPanel, this.weatherPanelContent);
                            }
                        });
                        ht.Default.startAnim({
                            duration: 800,
                            easing: t => t,
                            action: () => {
                            },
                            finishFunc: () => {
                                // this.coldStationRealTimePanelAnim();
                                // this.coldStationHostRunningDataPanelAnim();
                                panelAnim(this.coldStation_realTimePanel, this.coldStation_realTimePanelContent);
                                panelAnim(this.coldStation_hostRunningDataPanel, this.coldStation_hostRunningDataPanelContent);
                            }
                        });
                        ht.Default.startAnim({
                            duration: 1200,
                            easing: t => t,
                            action: () => {
                            },
                            finishFunc: () => {
                                // this.monitoringPanelAnim();
                                panelAnim(this.monitoringPanel, this.monitoringPanelContent);
                                this.showButtonAnim();
                                this.polyLineRoam(this.eyePath, 7000);
                            }
                        });
                    }
                });
            }
        });
    }

    // 数据统计面板动画
    dataStatisticsPanelAnim() {
        const self = this;
        const g2d = self.g2d;
        const g2dDm = g2d.dm();

        let dataStatisticsPanel_index = this.dataStatisticsPanel.getScaleX();

        ht.Default.startAnim({
            duration: 200,
            easing: Easing.swing,
            action: (v, t) => {
                this.dataStatisticsPanel.setScaleX(dataStatisticsPanel_index + (1 - dataStatisticsPanel_index) * v);
            },
            finishFunc: () => {
                // this.dataStatisticsPanelContent.eachChild(c => {
                ht.Default.startAnim({
                    duration: 1500,
                    easing: Easing.swing,
                    action: (v, t) => {
                        this.dataStatisticsPanelContent.eachChild(c => {
                            c.s('opacity', c.s('opacity') + (1 - c.s('opacity')) * v);
                        });
                    },
                    finishFunc: () => {

                    }
                });
                // })
            }
        });
    }


    //天气面板动画
    weatherPanelAnim() {
        const self = this;
        const g2d = self.g2d;
        const g2dDm = g2d.dm();

        let weatherPanel_index = this.weatherPanel.getScaleX();

        ht.Default.startAnim({
            duration: 200,
            easing: Easing.swing,
            action: (v, t) => {
                this.weatherPanel.setScaleX(weatherPanel_index + (1 - weatherPanel_index) * v);
            },
            finishFunc: () => {
                // this.weatherPanelContent.eachChild(c => {
                ht.Default.startAnim({
                    duration: 1500,
                    easing: Easing.swing,
                    action: (v, t) => {
                        this.weatherPanelContent.eachChild(c => {
                            c.s('opacity', c.s('opacity') + (1 - c.s('opacity')) * v);
                        });
                    },
                    finishFunc: () => {

                    }
                });
                // })
            }
        });
    }

    // 冷站数据面板动画
    coldStationRealTimePanelAnim() {
        const self = this;
        const g2d = self.g2d;
        const g2dDm = g2d.dm();

        let coldStation_realTimePanel_index = this.coldStation_realTimePanel.getScaleX();

        ht.Default.startAnim({
            duration: 200,
            easing: Easing.swing,
            action: (v, t) => {
                this.coldStation_realTimePanel.setScaleX(coldStation_realTimePanel_index + (1 - coldStation_realTimePanel_index) * v);
            },
            finishFunc: () => {
                // this.coldStation_realTimePanelContent.eachChild(c => {
                ht.Default.startAnim({
                    duration: 1500,
                    easing: Easing.swing,
                    action: (v, t) => {
                        this.coldStation_realTimePanelContent.eachChild(c => {
                            c.s('opacity', c.s('opacity') + (1 - c.s('opacity')) * v);
                        });
                    },
                    finishFunc: () => {

                    }
                });
                // })
            }
        });
    }

    // 实时监控面板动画
    monitoringPanelAnim() {
        const self = this;
        const g2d = self.g2d;
        const g2dDm = g2d.dm();

        let monitoringPanel_index = this.monitoringPanel.getScaleX();

        ht.Default.startAnim({
            duration: 200,
            easing: Easing.swing,
            action: (v, t) => {
                this.monitoringPanel.setScaleX(monitoringPanel_index + (1 - monitoringPanel_index) * v);
            },
            finishFunc: () => {
                this.monitoringPanelContent.eachChild(c => {
                    ht.Default.startAnim({
                        duration: 1500,
                        easing: Easing.swing,
                        action: (v, t) => {
                            c.s('opacity', c.s('opacity') + (1 - c.s('opacity')) * v);
                        }
                    });
                })
            }
        });
    }

    // 冷站系统能效指标面板动画
    coldStationEfficiencyIndexPanelAnim() {
        const self = this;
        const g2d = self.g2d;
        const g2dDm = g2d.dm();

        let coldStation_efficiencyIndexPanel_index = this.coldStation_efficiencyIndexPanel.getScaleX();

        ht.Default.startAnim({
            duration: 200,
            easing: Easing.swing,
            action: (v, t) => {
                this.coldStation_efficiencyIndexPanel.setScaleX(coldStation_efficiencyIndexPanel_index + (1 - coldStation_efficiencyIndexPanel_index) * v);
            },
            finishFunc: () => {
                // this.coldStation_realTimePanelContent.eachChild(c => {
                ht.Default.startAnim({
                    duration: 1500,
                    easing: Easing.swing,
                    action: (v, t) => {
                        this.coldStation_efficiencyIndexPanelContent.eachChild(c => {
                            c.s('opacity', c.s('opacity') + (1 - c.s('opacity')) * v);
                        });
                    },
                    finishFunc: () => {

                    }
                });
                // })
            }
        });
    }

    // 冷站主机运行数据面板动画
    coldStationHostRunningDataPanelAnim() {
        const self = this;
        const g2d = self.g2d;
        const g2dDm = g2d.dm();

        let coldStation_hostRunningDataPanel_index = this.coldStation_hostRunningDataPanel.getScaleX();

        ht.Default.startAnim({
            duration: 200,
            easing: Easing.swing,
            action: (v, t) => {
                this.coldStation_hostRunningDataPanel.setScaleX(coldStation_hostRunningDataPanel_index + (1 - coldStation_hostRunningDataPanel_index) * v);
            },
            finishFunc: () => {
                // this.coldStation_realTimePanelContent.eachChild(c => {
                ht.Default.startAnim({
                    duration: 1500,
                    easing: Easing.swing,
                    action: (v, t) => {
                        this.coldStation_hostRunningDataPanelContent.eachChild(c => {
                            c.s('opacity', c.s('opacity') + (1 - c.s('opacity')) * v);
                        });
                    },
                    finishFunc: () => {

                    }
                });
                // })
            }
        });
    }

    // 按钮显示动画
    showButtonAnim() {
        const self = this;
        const g2d = self.g2d;
        const g2dDm = g2d.dm();

        ht.Default.startAnim({
            duration: 2000,
            easing: Easing.swing,
            action: (v, t) => {
                this.button.eachChild(c => {
                    c.s('opacity', c.s('opacity') + (1 - c.s('opacity')) * v);
                })
            },
            finishFunc: () => {
                this.startColdStationPanelAnim();
                // g2dDm.addScheduleTask(this.coldStationPanelIntervalTimer2);
            }
        });
    }

    // 开启冷站面板动画
    startColdStationPanelAnim() {
        const self = this;
        const g2d = self.g2d;
        const g2dDm = g2d.dm();
        this.coldStationPanelAnim();
        this.coldStationPanelIntervalTimer = setInterval(() => {
            this.coldStationPanelAnim();
        }, 5000);
    }

    // 开启热站面板动画
    startHotStationPanelAnim() {
        const self = this;
        const g2d = self.g2d;
        const g2dDm = g2d.dm();
        this.hotStationPanelAnim();
        this.hotStationPanelIntervalTimer = setInterval(() => {
            this.hotStationPanelAnim();
        }, 5000)
    }

    openColdStationPanel() {
        const self = this;
        const g2d = self.g2d;
        const g2dDm = g2d.dm();

        let coldStation_realTimePanel_index = this.coldStation_realTimePanel.getScaleX();

        let coldStation_efficiencyIndexPanel_index = this.coldStation_efficiencyIndexPanel.getScaleX();

        let coldStation_hostRunningDataPanel_index = this.coldStation_hostRunningDataPanel.getScaleX();

        if (this.coldStationPanelIntervalTimer !== null) {
            clearInterval(this.coldStationPanelIntervalTimer);
            this.coldStationPanelIntervalTimer = null;
            // g2dDm.removeScheduleTask(this.coldStationPanelIntervalTimer2);
        }
        if (this.hotStationPanelIntervalTimer !== null) {
            clearInterval(this.hotStationPanelIntervalTimer);
            this.hotStationPanelIntervalTimer = null;
        }
        // g2dDm.removeScheduleTask(this.hotStationPanelIntervalTimer2);


        // 实时环比指标切换
        ht.Default.startAnim({
            duration: 300,
            easing: Easing.swing,
            action: (v, t) => {
                this.coldStation_realTimePanel.setScaleX(coldStation_realTimePanel_index + (1 - coldStation_realTimePanel_index) * v);
            },
            finishFunc: () => {
                ht.Default.startAnim({
                    duration: 700,
                    easing: Easing.swing,
                    action: (v, t) => {
                        this.coldStation_realTimePanelContent.eachChild(c => {
                            c.s('opacity', c.s('opacity') + (1 - c.s('opacity')) * v);
                        });
                    }
                });
            }
        });


        // 系统能效指标切换
        ht.Default.startAnim({
            duration: 300,
            easing: Easing.swing,
            action: (v, t) => {
                this.coldStation_efficiencyIndexPanel.setScaleX(coldStation_efficiencyIndexPanel_index + (1 - coldStation_efficiencyIndexPanel_index) * v);
            },
            finishFunc: () => {
                ht.Default.startAnim({
                    duration: 700,
                    easing: Easing.swing,
                    action: (v, t) => {
                        this.coldStation_efficiencyIndexPanelContent.eachChild(c => {
                            c.s('opacity', c.s('opacity') + (1 - c.s('opacity')) * v);
                        });
                    }
                });
            }
        });


        // 主机运行数据切换
        ht.Default.startAnim({
            duration: 300,
            easing: Easing.swing,
            action: (v, t) => {
                this.coldStation_hostRunningDataPanel.setScaleX(coldStation_hostRunningDataPanel_index + (1 - coldStation_hostRunningDataPanel_index) * v);
            },
            finishFunc: () => {
                ht.Default.startAnim({
                    duration: 700,
                    easing: Easing.swing,
                    action: (v, t) => {
                        this.coldStation_hostRunningDataPanelContent.eachChild(c => {
                            c.s('opacity', c.s('opacity') + (1 - c.s('opacity')) * v);
                        });
                    },
                    finishFunc: () => {
                        this.startColdStationPanelAnim();
                        // g2dDm.addScheduleTask(this.coldStationPanelIntervalTimer2);
                    }
                });
            }
        });

    }

    openHotStationPanel() {
        const self = this;
        const g2d = self.g2d;
        const g2dDm = g2d.dm();

        let hotStation_realTimePanel_index = this.hotStation_realTimePanel.getScaleX();

        let hotStation_efficiencyIndexPanel_index = this.hotStation_efficiencyIndexPanel.getScaleX();

        let hotStation_hostRunningDataPanel_index = this.hotStation_hostRunningDataPanel.getScaleX();

        if (this.coldStationPanelIntervalTimer !== null) {
            clearInterval(this.coldStationPanelIntervalTimer);
            this.coldStationPanelIntervalTimer = null;
        }
        if (this.hotStationPanelIntervalTimer !== null) {
            clearInterval(this.hotStationPanelIntervalTimer);
            this.hotStationPanelIntervalTimer = null;
            // g2dDm.removeScheduleTask(this.hotStationPanelIntervalTimer2);
        }
        // g2dDm.removeScheduleTask(this.coldStationPanelIntervalTimer2);


        // 实时环比指标切换
        ht.Default.startAnim({
            duration: 300,
            easing: Easing.swing,
            action: (v, t) => {
                this.hotStation_realTimePanel.setScaleX(hotStation_realTimePanel_index + (1 - hotStation_realTimePanel_index) * v);
            },
            finishFunc: () => {
                ht.Default.startAnim({
                    duration: 700,
                    easing: Easing.swing,
                    action: (v, t) => {
                        this.hotStation_realTimePanelContent.eachChild(c => {
                            c.s('opacity', c.s('opacity') + (1 - c.s('opacity')) * v);
                        });
                    }
                });
            }
        });


        // 系统能效指标切换
        ht.Default.startAnim({
            duration: 300,
            easing: Easing.swing,
            action: (v, t) => {
                this.hotStation_efficiencyIndexPanel.setScaleX(hotStation_efficiencyIndexPanel_index + (1 - hotStation_efficiencyIndexPanel_index) * v);
            },
            finishFunc: () => {
                ht.Default.startAnim({
                    duration: 700,
                    easing: Easing.swing,
                    action: (v, t) => {
                        this.hotStation_efficiencyIndexPanelContent.eachChild(c => {
                            c.s('opacity', c.s('opacity') + (1 - c.s('opacity')) * v);
                        });
                    }
                });
            }
        });


        // 主机运行数据切换
        ht.Default.startAnim({
            duration: 300,
            easing: Easing.swing,
            action: (v, t) => {
                this.hotStation_hostRunningDataPanel.setScaleX(hotStation_hostRunningDataPanel_index + (1 - hotStation_hostRunningDataPanel_index) * v);
            },
            finishFunc: () => {
                ht.Default.startAnim({
                    duration: 700,
                    easing: Easing.swing,
                    action: (v, t) => {
                        this.hotStation_hostRunningDataPanelContent.eachChild(c => {
                            c.s('opacity', c.s('opacity') + (1 - c.s('opacity')) * v);
                        });
                    },
                    finishFunc: () => {
                        this.startHotStationPanelAnim();
                        // g2dDm.addScheduleTask(this.hotStationPanelIntervalTimer2);
                    }
                });
            }
        });

    }

    closeColdStationPanel() {
        const self = this;
        const g2d = self.g2d;
        const g2dDm = g2d.dm();

        let coldStation_realTimePanel_index = this.coldStation_realTimePanel.getScaleX();

        let coldStation_efficiencyIndexPanel_index = this.coldStation_efficiencyIndexPanel.getScaleX();

        let coldStation_hostRunningDataPanel_index = this.coldStation_hostRunningDataPanel.getScaleX();

        if (this.coldStationPanelIntervalTimer !== null) {
            clearInterval(this.coldStationPanelIntervalTimer);
            this.coldStationPanelIntervalTimer = null;
        }
        if (this.hotStationPanelIntervalTimer !== null) {
            clearInterval(this.hotStationPanelIntervalTimer);
            this.hotStationPanelIntervalTimer = null;
            // g2dDm.removeScheduleTask(this.hotStationPanelIntervalTimer2);
        }
        // g2dDm.removeScheduleTask(this.coldStationPanelIntervalTimer2);


        // 实时环比指标切换
        ht.Default.startAnim({
            duration: 700,
            easing: Easing.swing,
            action: (v, t) => {
                this.coldStation_realTimePanelContent.eachChild(c => {
                    c.s('opacity', c.s('opacity') + (0 - c.s('opacity')) * v);
                });
            },
            finishFunc: () => {
                ht.Default.startAnim({
                    duration: 300,
                    easing: Easing.swing,
                    action: (v, t) => {
                        this.coldStation_realTimePanel.setScaleX(coldStation_realTimePanel_index + (0 - coldStation_realTimePanel_index) * v);
                    }
                });
            }
        });

        // 系统能效指标切换
        ht.Default.startAnim({
            duration: 700,
            easing: Easing.swing,
            action: (v, t) => {
                this.coldStation_efficiencyIndexPanelContent.eachChild(c => {
                    c.s('opacity', c.s('opacity') + (0 - c.s('opacity')) * v);
                });
            },
            finishFunc: () => {
                ht.Default.startAnim({
                    duration: 300,
                    easing: Easing.swing,
                    action: (v, t) => {
                        this.coldStation_efficiencyIndexPanel.setScaleX(coldStation_efficiencyIndexPanel_index + (0 - coldStation_efficiencyIndexPanel_index) * v);
                    }
                });
            }
        });

        // 主机运行数据切换
        ht.Default.startAnim({
            duration: 700,
            easing: Easing.swing,
            action: (v, t) => {
                this.coldStation_hostRunningDataPanelContent.eachChild(c => {
                    c.s('opacity', c.s('opacity') + (0 - c.s('opacity')) * v);
                });
            },
            finishFunc: () => {
                ht.Default.startAnim({
                    duration: 300,
                    easing: Easing.swing,
                    action: (v, t) => {
                        this.coldStation_hostRunningDataPanel.setScaleX(coldStation_hostRunningDataPanel_index + (0 - coldStation_hostRunningDataPanel_index) * v);
                    }
                });
            }
        });
    }

    closeHotStationPanel() {
        const self = this;
        const g2d = self.g2d;
        const g2dDm = g2d.dm();

        let hotStation_realTimePanel_index = this.hotStation_realTimePanel.getScaleX();


        let hotStation_efficiencyIndexPanel_index = this.hotStation_efficiencyIndexPanel.getScaleX();


        let hotStation_hostRunningDataPanel_index = this.hotStation_hostRunningDataPanel.getScaleX();

        if (this.coldStationPanelIntervalTimer !== null) {
            clearInterval(this.coldStationPanelIntervalTimer);
            this.coldStationPanelIntervalTimer = null;
            // g2dDm.removeScheduleTask(this.coldStationPanelIntervalTimer2);
        }
        if (this.hotStationPanelIntervalTimer !== null) {
            clearInterval(this.hotStationPanelIntervalTimer);
            this.hotStationPanelIntervalTimer = null;
        }
        // g2dDm.removeScheduleTask(this.hotStationPanelIntervalTimer2);


        // 实时环比指标切换
        ht.Default.startAnim({
            duration: 700,
            easing: Easing.swing,
            action: (v, t) => {
                this.hotStation_realTimePanelContent.eachChild(c => {
                    c.s('opacity', c.s('opacity') + (0 - c.s('opacity')) * v);
                });
            },
            finishFunc: () => {
                ht.Default.startAnim({
                    duration: 300,
                    easing: Easing.swing,
                    action: (v, t) => {
                        this.hotStation_realTimePanel.setScaleX(hotStation_realTimePanel_index + (0 - hotStation_realTimePanel_index) * v);
                    }
                });
            }
        });

        // 系统能效指标切换
        ht.Default.startAnim({
            duration: 700,
            easing: Easing.swing,
            action: (v, t) => {
                this.hotStation_efficiencyIndexPanelContent.eachChild(c => {
                    c.s('opacity', c.s('opacity') + (0 - c.s('opacity')) * v);
                });
            },
            finishFunc: () => {
                ht.Default.startAnim({
                    duration: 300,
                    easing: Easing.swing,
                    action: (v, t) => {
                        this.hotStation_efficiencyIndexPanel.setScaleX(hotStation_efficiencyIndexPanel_index + (0 - hotStation_efficiencyIndexPanel_index) * v);
                    }
                });
            }
        });

        // 主机运行数据切换
        ht.Default.startAnim({
            duration: 700,
            easing: Easing.swing,
            action: (v, t) => {
                this.hotStation_hostRunningDataPanelContent.eachChild(c => {
                    c.s('opacity', c.s('opacity') + (0 - c.s('opacity')) * v);
                });
            },
            finishFunc: () => {
                ht.Default.startAnim({
                    duration: 300,
                    easing: Easing.swing,
                    action: (v, t) => {
                        this.hotStation_hostRunningDataPanel.setScaleX(hotStation_hostRunningDataPanel_index + (0 - hotStation_hostRunningDataPanel_index) * v);
                    }
                });
            }
        });
    }

    // 切换到冷站过渡动画
    switchToColdStation() {
        const self = this;
        const g2d = self.g2d;
        const g2dDm = g2d.dm();

        let coldStation_realTimePanel_index = this.coldStation_realTimePanel.getScaleX();
        let hotStation_realTimePanel_index = this.hotStation_realTimePanel.getScaleX();

        let coldStation_efficiencyIndexPanel_index = this.coldStation_efficiencyIndexPanel.getScaleX();
        let hotStation_efficiencyIndexPanel_index = this.hotStation_efficiencyIndexPanel.getScaleX();

        let coldStation_hostRunningDataPanel_index = this.coldStation_hostRunningDataPanel.getScaleX();
        let hotStation_hostRunningDataPanel_index = this.hotStation_hostRunningDataPanel.getScaleX();

        if (this.coldStationPanelIntervalTimer !== null) {
            clearInterval(this.coldStationPanelIntervalTimer);
            this.coldStationPanelIntervalTimer = null;
            // g2dDm.removeScheduleTask(this.coldStationPanelIntervalTimer2);
        }
        if (this.hotStationPanelIntervalTimer !== null) {
            clearInterval(this.hotStationPanelIntervalTimer);
            this.hotStationPanelIntervalTimer = null;
        }
        // g2dDm.removeScheduleTask(this.hotStationPanelIntervalTimer2);


        // 实时环比指标切换
        ht.Default.startAnim({
            duration: 700,
            easing: Easing.swing,
            action: (v, t) => {
                this.hotStation_realTimePanelContent.eachChild(c => {
                    c.s('opacity', c.s('opacity') + (0 - c.s('opacity')) * v);
                });
            },
            finishFunc: () => {
                ht.Default.startAnim({
                    duration: 300,
                    easing: Easing.swing,
                    action: (v, t) => {
                        this.hotStation_realTimePanel.setScaleX(hotStation_realTimePanel_index + (0 - hotStation_realTimePanel_index) * v);
                    },
                    finishFunc: () => {
                        ht.Default.startAnim({
                            duration: 300,
                            easing: Easing.swing,
                            action: (v, t) => {
                                this.coldStation_realTimePanel.setScaleX(coldStation_realTimePanel_index + (1 - coldStation_realTimePanel_index) * v);
                            },
                            finishFunc: () => {
                                ht.Default.startAnim({
                                    duration: 700,
                                    easing: Easing.swing,
                                    action: (v, t) => {
                                        this.coldStation_realTimePanelContent.eachChild(c => {
                                            c.s('opacity', c.s('opacity') + (1 - c.s('opacity')) * v);
                                        });
                                    }
                                });
                            }
                        });
                    }
                });
            }
        });

        // 系统能效指标切换
        ht.Default.startAnim({
            duration: 700,
            easing: Easing.swing,
            action: (v, t) => {
                this.hotStation_efficiencyIndexPanelContent.eachChild(c => {
                    c.s('opacity', c.s('opacity') + (0 - c.s('opacity')) * v);
                });
            },
            finishFunc: () => {
                ht.Default.startAnim({
                    duration: 300,
                    easing: Easing.swing,
                    action: (v, t) => {
                        this.hotStation_efficiencyIndexPanel.setScaleX(hotStation_efficiencyIndexPanel_index + (0 - hotStation_efficiencyIndexPanel_index) * v);
                    },
                    finishFunc: () => {
                        ht.Default.startAnim({
                            duration: 300,
                            easing: Easing.swing,
                            action: (v, t) => {
                                this.coldStation_efficiencyIndexPanel.setScaleX(coldStation_efficiencyIndexPanel_index + (1 - coldStation_efficiencyIndexPanel_index) * v);
                            },
                            finishFunc: () => {
                                ht.Default.startAnim({
                                    duration: 700,
                                    easing: Easing.swing,
                                    action: (v, t) => {
                                        this.coldStation_efficiencyIndexPanelContent.eachChild(c => {
                                            c.s('opacity', c.s('opacity') + (1 - c.s('opacity')) * v);
                                        });
                                    }
                                });
                            }
                        });
                    }
                });
            }
        });

        // 主机运行数据切换
        ht.Default.startAnim({
            duration: 700,
            easing: Easing.swing,
            action: (v, t) => {
                this.hotStation_hostRunningDataPanelContent.eachChild(c => {
                    c.s('opacity', c.s('opacity') + (0 - c.s('opacity')) * v);
                });
            },
            finishFunc: () => {
                ht.Default.startAnim({
                    duration: 300,
                    easing: Easing.swing,
                    action: (v, t) => {
                        this.hotStation_hostRunningDataPanel.setScaleX(hotStation_hostRunningDataPanel_index + (0 - hotStation_hostRunningDataPanel_index) * v);
                    },
                    finishFunc: () => {
                        ht.Default.startAnim({
                            duration: 300,
                            easing: Easing.swing,
                            action: (v, t) => {
                                this.coldStation_hostRunningDataPanel.setScaleX(coldStation_hostRunningDataPanel_index + (1 - coldStation_hostRunningDataPanel_index) * v);
                            },
                            finishFunc: () => {
                                ht.Default.startAnim({
                                    duration: 700,
                                    easing: Easing.swing,
                                    action: (v, t) => {
                                        this.coldStation_hostRunningDataPanelContent.eachChild(c => {
                                            c.s('opacity', c.s('opacity') + (1 - c.s('opacity')) * v);
                                        });
                                    },
                                    finishFunc: () => {
                                        this.startColdStationPanelAnim();
                                        // g2dDm.addScheduleTask(this.coldStationPanelIntervalTimer2);
                                    }
                                });
                            }
                        });
                    }
                });
            }
        });

    }

    // 切换到热站过渡动画
    switchToHotStation() {
        const self = this;
        const g2d = self.g2d;
        const g2dDm = g2d.dm();

        let coldStation_realTimePanel_index = this.coldStation_realTimePanel.getScaleX();
        let hotStation_realTimePanel_index = this.hotStation_realTimePanel.getScaleX();

        let coldStation_efficiencyIndexPanel_index = this.coldStation_efficiencyIndexPanel.getScaleX();
        let hotStation_efficiencyIndexPanel_index = this.hotStation_efficiencyIndexPanel.getScaleX();

        let coldStation_hostRunningDataPanel_index = this.coldStation_hostRunningDataPanel.getScaleX();
        let hotStation_hostRunningDataPanel_index = this.hotStation_hostRunningDataPanel.getScaleX();

        if (this.coldStationPanelIntervalTimer !== null) {
            clearInterval(this.coldStationPanelIntervalTimer);
            this.coldStationPanelIntervalTimer = null;
        }
        if (this.hotStationPanelIntervalTimer !== null) {
            clearInterval(this.hotStationPanelIntervalTimer);
            this.hotStationPanelIntervalTimer = null;
            // g2dDm.removeScheduleTask(this.hotStationPanelIntervalTimer2);
        }
        // g2dDm.removeScheduleTask(this.coldStationPanelIntervalTimer2);


        // 实时环比指标切换
        ht.Default.startAnim({
            duration: 700,
            easing: Easing.swing,
            action: (v, t) => {
                this.coldStation_realTimePanelContent.eachChild(c => {
                    c.s('opacity', c.s('opacity') + (0 - c.s('opacity')) * v);
                });
            },
            finishFunc: () => {
                ht.Default.startAnim({
                    duration: 300,
                    easing: Easing.swing,
                    action: (v, t) => {
                        this.coldStation_realTimePanel.setScaleX(coldStation_realTimePanel_index + (0 - coldStation_realTimePanel_index) * v);
                    },
                    finishFunc: () => {
                        ht.Default.startAnim({
                            duration: 300,
                            easing: Easing.swing,
                            action: (v, t) => {
                                this.hotStation_realTimePanel.setScaleX(hotStation_realTimePanel_index + (1 - hotStation_realTimePanel_index) * v);
                            },
                            finishFunc: () => {
                                ht.Default.startAnim({
                                    duration: 700,
                                    easing: Easing.swing,
                                    action: (v, t) => {
                                        this.hotStation_realTimePanelContent.eachChild(c => {
                                            c.s('opacity', c.s('opacity') + (1 - c.s('opacity')) * v);
                                        });
                                    }
                                });
                            }
                        });
                    }
                });
            }
        });

        // 系统能效指标切换
        ht.Default.startAnim({
            duration: 700,
            easing: Easing.swing,
            action: (v, t) => {
                this.coldStation_efficiencyIndexPanelContent.eachChild(c => {
                    c.s('opacity', c.s('opacity') + (0 - c.s('opacity')) * v);
                });
            },
            finishFunc: () => {
                ht.Default.startAnim({
                    duration: 300,
                    easing: Easing.swing,
                    action: (v, t) => {
                        this.coldStation_efficiencyIndexPanel.setScaleX(coldStation_efficiencyIndexPanel_index + (0 - coldStation_efficiencyIndexPanel_index) * v);
                    },
                    finishFunc: () => {
                        ht.Default.startAnim({
                            duration: 300,
                            easing: Easing.swing,
                            action: (v, t) => {
                                this.hotStation_efficiencyIndexPanel.setScaleX(hotStation_efficiencyIndexPanel_index + (1 - hotStation_efficiencyIndexPanel_index) * v);
                            },
                            finishFunc: () => {
                                ht.Default.startAnim({
                                    duration: 700,
                                    easing: Easing.swing,
                                    action: (v, t) => {
                                        this.hotStation_efficiencyIndexPanelContent.eachChild(c => {
                                            c.s('opacity', c.s('opacity') + (1 - c.s('opacity')) * v);
                                        });
                                    }
                                });
                            }
                        });
                    }
                });
            }
        });

        // 主机运行数据切换
        ht.Default.startAnim({
            duration: 700,
            easing: Easing.swing,
            action: (v, t) => {
                this.coldStation_hostRunningDataPanelContent.eachChild(c => {
                    c.s('opacity', c.s('opacity') + (0 - c.s('opacity')) * v);
                });
            },
            finishFunc: () => {
                ht.Default.startAnim({
                    duration: 300,
                    easing: Easing.swing,
                    action: (v, t) => {
                        this.coldStation_hostRunningDataPanel.setScaleX(coldStation_hostRunningDataPanel_index + (0 - coldStation_hostRunningDataPanel_index) * v);
                    },
                    finishFunc: () => {
                        ht.Default.startAnim({
                            duration: 300,
                            easing: Easing.swing,
                            action: (v, t) => {
                                this.hotStation_hostRunningDataPanel.setScaleX(hotStation_hostRunningDataPanel_index + (1 - hotStation_hostRunningDataPanel_index) * v);
                            },
                            finishFunc: () => {
                                ht.Default.startAnim({
                                    duration: 700,
                                    easing: Easing.swing,
                                    action: (v, t) => {
                                        this.hotStation_hostRunningDataPanelContent.eachChild(c => {
                                            c.s('opacity', c.s('opacity') + (1 - c.s('opacity')) * v);
                                        });
                                    },
                                    finishFunc: () => {
                                        this.startHotStationPanelAnim();
                                        // g2dDm.addScheduleTask(this.hotStationPanelIntervalTimer2);
                                    }
                                });
                            }
                        });
                    }
                });
            }
        });
    }

    // 面板显示完动画效果
    panelTime() {
        const self = this;
        const g2d = self.g2d;
        const g2dDm = g2d.dm();

        let now = new Date();
        // 日期数据处理
        for (let i = 1; i <= 4; i++) {
            let futureDay = new Date(now.valueOf() + i * 24 * 60 * 60 * 1000);
            g2dDm.getDataByTag('date' + i).s('text', formatDate(futureDay, 'M月dd日'));
            g2dDm.getDataByTag('weekDay' + i).s('text', formatDate(futureDay, '星期w'));
        }
    }

    // 冷站面板动画
    coldStationPanelAnim() {
        const self = this;
        const g2d = self.g2d;
        const g2dDm = g2d.dm();

        // 实时环比指标和主机运行数据跳动
        for (let i = 1, l = 15; i <= l; i++) {
            let coldProgressBarNum = 'coldProgressBar' + i;
            let coldTextNum = 'coldText' + i;
            let progressBar = g2dDm.getDataByTag(coldProgressBarNum);
            let text = g2dDm.getDataByTag(coldTextNum);
            let randomNum = Math.random() * (100 - 1 + 1) + 1;
            if (progressBar && text) {
                if (i < 8) {
                    text.a('ht.value', randomNum);
                } else {
                    text.s('text', randomNum.toFixed(2));
                }
                setValueWithAnimation(progressBar, 'percent', randomNum / progressBar.a('max'));
            }
        }
        // 系统能效指标数据跳动
        for (let i = 1, l = 6; i <= l; i++) {
            let coldPanelTextNum = 'coldPanelText' + i;
            let coldPanelText = g2dDm.getDataByTag(coldPanelTextNum);
            let randomNum = Math.random() * (9 - 1 + 1) + 1;
            coldPanelText.s('text', randomNum.toFixed(2));
        }
    }

    // 热站面板动画
    hotStationPanelAnim() {
        const self = this;
        const g2d = self.g2d;
        const g2dDm = g2d.dm();

        // 实时环比指标和主机运行数据跳动
        for (let i = 1, l = 15; i <= l; i++) {
            let hotProgressBarNum = 'hotProgressBar' + i;
            let hotTextNum = 'hotText' + i;
            let progressBar = g2dDm.getDataByTag(hotProgressBarNum);
            let text = g2dDm.getDataByTag(hotTextNum);
            let randomNum = Math.random() * (100 - 1 + 1) + 1;
            if (progressBar && text) {
                if (i < 8) {
                    text.a('ht.value', randomNum);
                } else {
                    text.s('text', randomNum.toFixed(2));
                }
                setValueWithAnimation(progressBar, 'percent', randomNum / progressBar.a('max'));
            }
        }

        // 系统能效指标数据跳动
        for (let i = 1, l = 6; i <= l; i++) {
            let hotPanelTextNum = 'hotPanelText' + i;
            let hotPanelText = g2dDm.getDataByTag(hotPanelTextNum);
            let randomNum = Math.random() * (9 - 1 + 1) + 1;
            hotPanelText.s('text', randomNum.toFixed(2));
        }

    }


    /**
     * @description 三维场景的加载
     * @memberof App
     */
    load3D() {
        const g3d = this.g3d;
        const g3dDm = this.g3dDm;
        ht.Default.xhrLoad('scenes/-ing/线框园区/demo.json', (json) => {
            if (!json) return;
            g3dDm.deserialize(json);

            // 设置三维视图的中心点和相机位置
            g3d.setCenter([-342, -64, 389]);
            g3d.setEye([-355, 10833, 2642]);

            // 设置最远距离
            g3d.setFar(1000000);
            // 获取球图标，设置为天空球
            let skybox = g3dDm.getDataByTag('skyBox');
            g3d.setSkyBox(skybox);

            const modelList = [];
            let flyAnim;
            const flyMap = {};
            const flyDltMap = {fly1: 5, fly2: 8, fly3: 10};
            let traffic = g3dDm.getDataByTag('traffic');
            let location = 0;
            let HotWaterTankTall = 0;
            let coldWaterTankTall1 = 0;
            let coldWaterTankTall2 = 7;
            let cold_fan = g3dDm.getDataByTag('cold_fan');
            let heat_fan = g3dDm.getDataByTag('heat_fan');
            let coldFlow_blue = g3dDm.getDataByTag('coldFlow_blue');
            let coldFlow_yellow = g3dDm.getDataByTag('coldFlow_yellow');
            let heatFlow_blue = g3dDm.getDataByTag('heatFlow_blue');
            let heatFlow_yellow = g3dDm.getDataByTag('heatFlow_yellow');
            let hotWaterTank = g3dDm.getDataByTag('hotWaterTank');
            let coldWaterTank1 = g3dDm.getDataByTag('coldWaterTank1');
            let coldWaterTank2 = g3dDm.getDataByTag('coldWaterTank2');
            this.building_glass = g3dDm.getDataByTag('building_glass');
            this.building_box = g3dDm.getDataByTag('building_box');
            this.building = g3dDm.getDataByTag('building');
            this.floor = g3dDm.getDataByTag('floor');
            this.elevator = g3dDm.getDataByTag('elevator');
            this.coldStation = g3dDm.getDataByTag('coldStation');
            this.hotStation = g3dDm.getDataByTag('hotStation');
            this.unitStation = g3dDm.getDataByTag('unitStation');
            let lightRing = this.lightRing = g3dDm.getDataByTag('lightRing');
            let eyePath = this.eyePath = g3dDm.getDataByTag('eyePath');

            this.floor1 = g3dDm.getDataByTag('floor1');
            this.floor2 = g3dDm.getDataByTag('floor2');
            this.floor3 = g3dDm.getDataByTag('floor3');
            this.floor4 = g3dDm.getDataByTag('floor4');
            this.floor5 = g3dDm.getDataByTag('floor5');
            this.floor6 = g3dDm.getDataByTag('floor6');
            this.floor7 = g3dDm.getDataByTag('floor7');
            this.floor8 = g3dDm.getDataByTag('floor8');
            this.floor9 = g3dDm.getDataByTag('floor9');
            this.floor10 = g3dDm.getDataByTag('floor10');

            this.panel1 = g3dDm.getDataByTag('panel1');
            this.panel2 = g3dDm.getDataByTag('panel2');
            this.panel3 = g3dDm.getDataByTag('panel3');
            this.panel4 = g3dDm.getDataByTag('panel4');
            this.panel5 = g3dDm.getDataByTag('panel5');
            this.panel6 = g3dDm.getDataByTag('panel6');
            this.panel7 = g3dDm.getDataByTag('panel7');

            // 电梯数组
            this.elevatorList = [];
            // 初始化电梯执行动画
            this.animationElevatorMap = {};
            // 初始化电梯运动间隔动画
            this.timeoutElevatorMap = {};
            // 初始化电梯，根据数量获取电梯并加入到电梯数组elevatorList中
            for (let i = 1; i <= 3; i++) {
                const tag = 'elevator' + i;
                this.elevatorList.push(g3dDm.getDataByTag(tag));
            }

            // 模型加载完后执行动画
            g3dDm.each(d => {
                const shape3d = d.s('shape3d');
                if (!shape3d || !shape3d.endsWith('.json')) return;

                if (ht.Default.getShape3dModel(shape3d)) return;

                modelList.push(shape3d);
            });
            ht.Default.handleModelLoaded = (name, model) => {
                const index = modelList.indexOf(name);
                if (index < 0) return;

                modelList.splice(index, 1);

                // console.log(modelList)
                if (modelList.length > 91) return;

                ht.Default.handleModelLoaded = () => {
                };

                // 模型加载完侯，默认执行场景切换动画
                g3d.moveCamera([257.54842765918545, 713.7549555340285, 1485.9259185335227], [7, 40, 144], {
                    duration: 2000,
                    finishFunc: () => {
                        // this.load2D();
                        // this.polyLineRoam(this.eyePath, 7000);
                    }
                });

            };

            // 车流图元的初始化
            // let traffic = g3dDm.getDataByTag('traffic');
            // 圆环扩散图元的初始化
            // let lightRing = this.lightRing = g3dDm.getDataByTag('lightRing');
            // 飞光图元设置三种透明状态数组集合flyMap的初始化
            [1, 2, 3].forEach(i => {
                const data = flyMap['fly' + i] = g3dDm.getDataByTag('fly' + i);
                data.eachChild(d => {
                    d.s({
                        // 打开透明度
                        'shape3d.transparent': true,
                        // 根据不同的数组集合设置不同的透明度
                        'shape3d.opacity': i === 3 ? 0.5 : 0.7,
                        // 设置沿着y轴自动旋转
                        'shape3d.autorotate': 'y'
                    });
                });
            });

            if (this.flyAnim) return;
            this.flyAnim = loop(() => {
                // 飞光
                for (let k in flyMap) {
                    const data = flyMap[k];
                    let e = data.getElevation() + flyDltMap[k];
                    if (e >= 500) e = -400;
                    data.setElevation(e);
                }

                // 车流
                traffic.eachChild(c => {
                    c.s('all.uv.offset', [location, 0]);
                });
                // 冷站流动
                coldFlow_blue.eachChild(c => {
                    c.s('shape3d.uv.offset', [-location, 0]);
                });
                coldFlow_yellow.eachChild(c => {
                    c.s('shape3d.uv.offset', [location, 0]);
                });
                // 热站流动
                heatFlow_blue.eachChild(c => {
                    c.s('shape3d.uv.offset', [-location, 0]);
                });
                heatFlow_yellow.eachChild(c => {
                    c.s('shape3d.uv.offset', [location, 0]);
                });
                location -= 0.03;

                // 风扇
                cold_fan.eachChild(c => {
                    c.setRotation3d(c.r3()[0], c.r3()[1] + (Math.PI / 10), c.r3()[2]);
                });
                // 热站风扇
                heat_fan.eachChild(c => {
                    c.setRotation3d(c.r3()[0], c.r3()[1] + (Math.PI / 10), c.r3()[2]);
                });

                // 旋转震荡波透明度渐降
                let percent = lightRing.a('percent') || 0,
                    scale = 15 * percent + 0.5;
                lightRing.setScale3d([scale + 1, scale, scale + 1]);
                lightRing.s('shape3d.opacity', (1 - percent) * 0.5);
                percent += 0.01;
                if (percent >= 1) {
                    percent = 0;
                }
                lightRing.a('percent', percent);

                HotWaterTankTall += 0.25;
                if (HotWaterTankTall > 15) {
                    HotWaterTankTall = 0;
                }
                coldWaterTankTall1 += 0.25;
                if (coldWaterTankTall1 > 20) {
                    coldWaterTankTall1 = 0;
                }
                coldWaterTankTall2 += 0.25;
                if (coldWaterTankTall2 > 20) {
                    coldWaterTankTall2 = 0;
                }
                hotWaterTank.setTall(HotWaterTankTall);
                coldWaterTank1.setTall(coldWaterTankTall1);
                coldWaterTank2.setTall(coldWaterTankTall2);

            }, 50);

        });
    }


    polyLineRoam(data, time) {
        const g3d = this.g3d;
        const g3dDm = this.g3dDm;
        this.roamButton.a('active', true);
        this.roamAnim = ht.Default.startAnim({
            duration: time,
            easing: t => t,
            action: (v, t) => {
                let cache = ht.Default.getLineCacheInfo(data.getPoints(), data.getSegments());
                let pathLength = ht.Default.getLineLength(cache);
                if (v > 1) v = 1;
                var len = (1 - v) * pathLength;
                let offset = ht.Default.getLineOffset(cache, len);

                if (v > 1) v = 1;

                var point = offset.point,
                    px = point.x,
                    py = point.y,
                    pz = point.z;

                g3d.setEye(px, py, pz);
                // console.log(px, py, pz);
                g3d.setCenter(7, 40, 144);
            },
            finishFunc: () => {
                this.roam1();
            }
        });
    }

    // 切换到冷站视角
    roam1() {
        const g3d = this.g3d;
        const g3dDm = this.g3dDm;
        this.roamAnim = moveCamera(g3d, [-291, -8, 283], [148, -400, 171], {
            duration: 1000,
            easing: t => t * t,
            finishFunc: () => {
                this.roam2();
            }
        });
    }

    // 冷站视角停留
    roam2() {
        const g3d = this.g3d;
        const g3dDm = this.g3dDm;
        this.roamAnim = ht.Default.startAnim({
            duration: 2000,
            easing: t => t,
            action: (v, t) => {
            },
            finishFunc: () => {
                this.roam3();
            }
        });
    }

    // 切换到楼层
    roam3() {
        const g3d = this.g3d;
        const g3dDm = this.g3dDm;
        this.roamAnim = moveCamera(g3d, [-313, 206, 322], [-187, 147, 228], {
            duration: 1000,
            easing: t => t * t,
            finishFunc: () => {
                this.roam4();
            }
        });
    }

    // 楼层视角停留
    roam4() {
        const g3d = this.g3d;
        const g3dDm = this.g3dDm;
        this.roamAnim = ht.Default.startAnim({
            duration: 2000,
            easing: t => t,
            action: (v, t) => {
            },
            finishFunc: () => {
                this.roam5();
            }
        });
    }

    //切换到主视角
    roam5() {
        const g3d = this.g3d;
        const g3dDm = this.g3dDm;
        this.roamAnim = moveCamera(g3d, [-201, 483, 813], [-196, 225, 81], {
            duration: 2000,
            easing: t => t * t,
            finishFunc: () => {
                this.roam6();
            }
        });
    }

    // 主视角停留
    roam6() {
        const g3d = this.g3d;
        const g3dDm = this.g3dDm;
        this.roamAnim = ht.Default.startAnim({
            duration: 1000,
            easing: t => t,
            action: (v, t) => {
            },
            finishFunc: () => {
                this.roam7();
            }
        });
    }

    // 切换到热站
    roam7() {
        const g3d = this.g3d;
        const g3dDm = this.g3dDm;
        this.roamAnim = moveCamera(g3d, [410, 182, 130], [337, 45, -19], {
            duration: 2000,
            easing: t => t * t,
            finishFunc: () => {
                this.roam8();
            }
        });
    }

    // 热站视角停留
    roam8() {
        const g3d = this.g3d;
        const g3dDm = this.g3dDm;
        this.roamAnim = ht.Default.startAnim({
            duration: 2000,
            easing: t => t,
            action: (v, t) => {
            },
            finishFunc: () => {
                this.roam9();
            }
        });
    }

    //切换到主视角
    roam9() {
        const g3d = this.g3d;
        const g3dDm = this.g3dDm;
        this.roamAnim = moveCamera(g3d, [257.54842765918545, 713.7549555340285, 1485.9259185335227], [7, 40, 144], {
            duration: 2000,
            easing: t => t * t,
            finishFunc: () => {
                this.roam10();
            }
        });
    }

    // 主视角停留
    roam10() {
        const g3d = this.g3d;
        const g3dDm = this.g3dDm;
        this.roamAnim = ht.Default.startAnim({
            duration: 1000,
            easing: t => t,
            action: (v, t) => {
            },
            finishFunc: () => {
                this.polyLineRoam(this.eyePath, 7000);
            }
        });
    }

    /**
     * @description 二维场景加载完成后的处理操作
     * @memberof App
     */
    loaded2DHandler() {
        const g2d = this.g2d;
        const g3d = this.g3d;
        const g2dDm = this.g2dDm;
        const g3dDm = this.g3dDm;

        let button = [this.intelligentBuildingButton, this.coolingCentralStationButton, this.heatingCentralStationButton, this.floorNavigationButton, this.parkingButton, this.elevatorButton, this.roamButton];
        let parkingScenceButton = [this.intelligentBuildingButton, this.coolingCentralStationButton, this.heatingCentralStationButton, this.floorNavigationButton, this.elevatorButton, this.roamButton];
        let coolingCentralStationAnimation = this.coolingCentralStationAnimation = null;
        let heatingCentralStationAnimation = this.heatingCentralStationAnimation = null;
        let floorNavigationAnimation = this.floorNavigationAnimation = null;
        let boxAnimation = this.boxAnimation = null;
        let intelligentBuildingAnimation = this.intelligentBuildingAnimation = null;
        let elevatorAnimation = this.elevatorAnimation = null;

        this.roamButton.s('onDown', () => {
            this.buttonTearDown();
            let active = this.roamButton.a('active');
            button.forEach(btn => {
                btn.a('active', false);
            });
            this.roamButton.a('active', !active);
            if (active) {
                if (this.roamAnim !== null) {
                    this.roamAnim.pause();
                    this.roamAnim = null;
                }
                g3d.moveCamera([257.54842765918545, 713.7549555340285, 1485.9259185335227], [7, 40, 144], {
                    duration: 2000,
                    finishFunc: () => {
                    }
                });

            } else {
                // if (g3d.getCenter() !== [7, 40, 144]) {
                //     console.log(g3d.getEye())
                //     console.log(g3d.getCenter())
                //     g3d.moveCamera([257.54842765918545, 713.7549555340285, 1485.9259185335227], [7, 40, 144], {
                //         duration: 2000,
                //         finishFunc: () => {
                //             this.polyLineRoam(this.eyePath, 8000);
                //         }
                //     });
                // } else {
                //     this.polyLineRoam(this.eyePath, 8000);
                // }
                // this.polyLineRoam(this.eyePath, 8000);
                g3d.moveCamera([257.54842765918545, 713.7549555340285, 1485.9259185335227], [7, 40, 144], {
                    duration: 500,
                    finishFunc: () => {
                        this.polyLineRoam(this.eyePath, 7000);
                    }
                });
            }
        });

        this.parkingButton.s('onDown', () => {
            this.buttonTearDown();
            let active = this.parkingButton.a('active');
            button.forEach(btn => {
                btn.a('active', false);
            });
            this.parkingButton.a('active', !active);
            if (active) {
                this.parkingTearDown(g3d);
                g3dDm.clear();
                this.load3D();
                // if (this.coldStation_realTimePanel.getScaleX() === 0) {
                //     this.openColdStationPanel();
                // } else if (this.hotStation_realTimePanel.getScaleX() === 0) {
                //     this.openHotStationPanel();
                // }
                g3d.moveCamera([257.54842765918545, 713.7549555340285, 1485.9259185335227], [7, 40, 144], {
                    duration: 2000,
                    finishFunc: () => {
                        // this.polyLineRoam(this.eyePath, 8000);
                        this.openColdStationPanel();
                        parkingScenceButton.forEach(btn => {
                            btn.s('2d.visible', true);
                        });
                    }
                });
            } else {
                if (this.flyAnim !== null) {
                    this.flyAnim.pause();
                    this.flyAnim = null;
                }
                if (this.roamAnim !== null) {
                    this.roamAnim.pause();
                    this.roamAnim = null;
                }
                this.elevatorTearDown()
                g3dDm.clear();
                ht.Default.xhrLoad('scenes/美的demo 3.json', (json) => {
                    if (!json) return;
                    g3dDm.deserialize(json);

                    g3d.setEye([257, 714, 1486]);
                    g3d.setCenter([7, 40, 144]);

                    g3d.moveCamera([-1083, 886, 1353], [-616, 46, 152], {
                        duration: 2000,
                        finishFunc: () => {
                            parkingScenceButton.forEach(btn => {
                                btn.s('2d.visible', false)
                            });
                            // this.createPolyLine(eyePath, 15000)
                            if (this.coldStation_realTimePanel.getScaleX() === 1) {
                                this.closeColdStationPanel();
                            } else if (this.hotStation_realTimePanel.getScaleX() === 1) {
                                this.closeHotStationPanel();
                            }
                        }
                    });

                    this.animationMap = {};
                    this.timeoutMap = {};
                    this.loopAnimation = null;

                    this.arrowMap = {
                        left: [],
                        front: [],
                        right: []
                    };

                    this.getDataAtFunc = null;
                    this.getDataInfoAtFunc = null;
                    this.restartStatus = 0;

                    this.panelList = g3dDm.getDataByTag('panelList');

                    const func = (d) => {
                        const displayName = d.getDisplayName();
                        const list = this.arrowMap[displayName];
                        if (list) list.push(d);

                        d.eachChild(func);
                    };
                    this.panelList.eachChild(func);

                    this.light1 = g3dDm.getDataByTag('light1');
                    this.light2 = g3dDm.getDataByTag('light2');
                    this.light3 = g3dDm.getDataByTag('light3');
                    this.light4 = g3dDm.getDataByTag('light4');

                    this.car1 = g3dDm.getDataByTag('car1');
                    this.car2 = g3dDm.getDataByTag('car2');
                    this.car3 = g3dDm.getDataByTag('car3');

                    this.parkingSetup(g3d);
                    g3d.mi(this.handleInteractive, this);
                });

            }

        });

        this.intelligentBuildingButton.s('onDown', () => {
            this.buttonTearDown();
            let active = this.intelligentBuildingButton.a('active');
            button.forEach(btn => {
                btn.a('active', false);
            });
            this.intelligentBuildingButton.a('active', !active);
            if (active) {
                // 按钮控制
                this.parkingButton.s('2d.visible', true);
                this.coolingCentralStationButton.s('2d.visible', true);
                this.heatingCentralStationButton.s('2d.visible', true);
                this.floorNavigationButton.s('2d.visible', true);
                this.elevatorButton.s('2d.visible', true);
                this.building.eachChild(c => {
                    c.s({
                        'shape3d.transparent': false,
                    });
                });
                tweenColor(this.building_glass, 'wf.color', 'rgba(21,69,79,0.20)', 'rgba(55,65,66,1)', {
                    duration: 2000,
                    easing: t => t
                });
                tweenColor(this.building_glass, 'shape3d.blend', 'rgba(0,53,102,0.1)', 'rgba(0,53,102,1)', {
                    duration: 2000,
                    easing: t => t
                });
                tweenColor(this.building_box, 'wf.color', 'rgba(56,156,255,0.03)', 'rgba(72,149,232,1)', {
                    duration: 2000,
                    easing: t => t
                });
                tweenColor(this.building_box, 'shape3d.blend', 'rgba(120,180,255,0)', 'rgba(120,180,255,1)', {
                    duration: 2000,
                    easing: t => t,
                    finishFunc: () => {
                        this.hideBuilding();
                        this.floor.eachChild(c => {
                            setNodeVisible(c, false);
                        })
                    }
                });
            } else {
                if (this.roamAnim !== null) {
                    this.roamAnim.pause();
                    this.roamAnim = null;
                }
                // 按钮控制
                this.parkingButton.s('2d.visible', false);
                this.coolingCentralStationButton.s('2d.visible', false);
                this.heatingCentralStationButton.s('2d.visible', false);
                this.floorNavigationButton.s('2d.visible', false);
                this.elevatorButton.s('2d.visible', false);
                moveCamera(g3d, [134.65597557350335, 399.7873654895006, 1617.6832865564083], [7, 40, 144], {
                    duration: 2000,
                    easing: t => t * t,
                    finishFunc: () => {
                        this.building.eachChild(c => {
                            c.s({
                                'shape3d.transparent': true,
                            });
                        });
                        tweenColor(this.building_glass, 'wf.color', 'rgba(55,65,66,1)', 'rgba(21,69,79,0.20)', {
                            duration: 2000,
                            easing: t => t
                        });
                        tweenColor(this.building_glass, 'shape3d.blend', 'rgba(0,53,102,1)', 'rgba(0,53,102,0.1)', {
                            duration: 2000,
                            easing: t => t,
                        });
                        tweenColor(this.building_box, 'wf.color', 'rgba(72,149,232,1)', 'rgba(56,156,255,0.03)', {
                            duration: 2000,
                            easing: t => t
                        });
                        tweenColor(this.building_box, 'shape3d.blend', 'rgba(120,180,255,1)', 'rgba(120,180,255,0)', {
                            duration: 2000,
                            easing: t => t,
                            finishFunc: () => {
                                this.floor.eachChild(c => {
                                    setNodeVisible(c, true);
                                });
                                this.floorLighting = 1;
                                this.showBuilding();
                            }
                        });
                    }
                });

            }
        });


        // 设置图元可交互
        // this.coolingCentralStationButton.s('interactive', true);
        // 通过数据绑定监听到onDown执行按下的事件
        this.coolingCentralStationButton.s('onDown', () => {
            // 切换到冷站时，2d面板所执行的切换动画
            this.switchToColdStation();
            // 按钮初始化
            this.buttonTearDown();
            // 按钮按下效果的状态
            let active = this.coolingCentralStationButton.a('active');
            // button为按钮集合数组，当按下电梯按钮，其他按钮默认false
            button.forEach(btn => {
                btn.a('active', false);
            });
            // 冷站按钮的状态切换
            this.coolingCentralStationButton.a('active', !active);
            // 根据冷站按钮的状态执行切换到冷站或者切换回主视角
            if (active) {
                // 相机移动切换到主视角
                moveCamera(g3d, [257.54842765918545, 713.7549555340285, 1485.9259185335227], [7, 40, 144], {
                    duration: 2000,
                    easing: t => t * t
                });
            } else {
                // 漫游动画对象如果不为空，则暂停漫游动画对象并且设置为空
                if (this.roamAnim !== null) {
                    this.roamAnim.pause();
                    this.roamAnim = null;
                }
                // 相机移动切换到冷站视角
                coolingCentralStationAnimation = moveCamera(g3d, [-291, -8, 283], [148, -400, 171], {
                    duration: 2000,
                    easing: t => t * t
                });
            }
        });

        this.heatingCentralStationButton.s('onDown', () => {
            this.switchToHotStation();
            this.buttonTearDown();
            let active = this.heatingCentralStationButton.a('active');
            button.forEach(btn => {
                btn.a('active', false);
            });
            this.heatingCentralStationButton.a('active', !active);
            if (active) {
                // 恢复视角
                // g3d.moveCamera([622, 698, 1394], [-87, -68, -347], {
                //     duration: 2000,
                //     easing: t => t * t
                // });
                moveCamera(g3d, [257.54842765918545, 713.7549555340285, 1485.9259185335227], [7, 40, 144], {
                    duration: 2000,
                    easing: t => t * t
                });
            } else {
                // 热站视角
                // heatingCentralStationAnimation = g3d.moveCamera([422, 179, 142], [158, -144, -455], {
                //     duration: 2000,
                //     easing: t => t * t
                // });
                if (this.roamAnim !== null) {
                    this.roamAnim.pause();
                    this.roamAnim = null;
                }
                heatingCentralStationAnimation = moveCamera(g3d, [410, 182, 130], [337, 45, -19], {
                    duration: 2000,
                    easing: t => t * t
                });
            }
        });
        // 点击按钮执行以下方法
        this.floorNavigationButton.s('onDown', () => {
            // 按钮初始化
            this.buttonTearDown();
            // 按钮按下效果的状态
            let active = this.floorNavigationButton.a('active');
            // button为按钮集合数组，当按下电梯按钮，其他按钮默认false
            button.forEach(btn => {
                btn.a('active', false);
            });
            // 中央末端楼层按钮状态切换
            this.floorNavigationButton.a('active', !active);
            // 根据中央末端楼层按钮状态执行智慧节能或者切换回主视角
            if (active) {
                // 按钮控制
                this.parkingButton.s('2d.visible', true);
                this.coolingCentralStationButton.s('2d.visible', true);
                this.heatingCentralStationButton.s('2d.visible', true);
                this.intelligentBuildingButton.s('2d.visible', true);
                this.elevatorButton.s('2d.visible', true);

                    boxAnimation.pause();
                    boxAnimation = null;
                for (let i = 0, l = 16; i <= l - 1; i++) {
                    let roomBox, tag;
                    tag = i + 1;
                    roomBox = 'box' + tag;
                    let box = g3dDm.getDataByTag(roomBox);
                    box.s('shape3d.blend', 'rgb(51,153,255)');
                    box.s('wf.color', 'rgb(51,153,255)');
                }
                // 切换到主视角
                moveCamera(g3d, [257.54842765918545, 713.7549555340285, 1485.9259185335227], [7, 40, 144], {
                    duration: 2000,
                    easing: t => t * t
                });
            } else {
                if (this.roamAnim !== null) {
                    this.roamAnim.pause();
                    this.roamAnim = null;
                }
                // 按钮控制
                this.parkingButton.s('2d.visible', false);
                this.coolingCentralStationButton.s('2d.visible', false);
                this.heatingCentralStationButton.s('2d.visible', false);
                this.intelligentBuildingButton.s('2d.visible', false);
                this.elevatorButton.s('2d.visible', false);
                // 切换到中央末端楼层视角
                floorNavigationAnimation = moveCamera(g3d, [-313, 206, 322], [-187, 147, 228], {
                    duration: 2000,
                    easing: t => t * t,
                    finishFunc: () => {
                        let index = 0;
                        boxAnimation = loop(() => {
                            for (let i = 0, l = 16; i <= l - 1; i++) {
                                let roomTag, roomBox, tag;
                                tag = i + 1;
                                roomTag = 'boxPanel' + tag;
                                roomBox = 'box' + tag;

                                let panel = g3dDm.getDataByTag(roomTag);
                                let box = g3dDm.getDataByTag(roomBox);
                                if (panel) {
                                    panel.a('valueT', boxData[index][i].temperature + '℃');
                                    panel.a('valueK', boxData[index][i].frequency + 'Hz');
                                    // 手动更新缓存的面板信息
                                    g3d.invalidateShape3dCachedImage(panel);
                                    // 根据温度判断设备的颜色
                                    if (box && parseFloat(panel.a('valueT')) < 26) {
                                        box.s('shape3d.blend', 'rgb(4,67,176)');
                                        box.s('wf.color', 'rgb(4,67,176)');
                                    } else if (box && parseFloat(panel.a('valueT')) >= 26 && parseFloat(panel.a('valueT')) <= 28) {
                                        box.s('shape3d.blend', 'rgb(28,189,87)');
                                        box.s('wf.color', 'rgb(28,189,87)');
                                    } else if (box && parseFloat(panel.a('valueT')) > 28) {
                                        box.s('shape3d.blend', 'rgb(181,43,43)');
                                        box.s('wf.color', 'rgb(181,43,43)');
                                    }
                                }
                            }
                            index++;
                            if (index >= 10) {
                                boxAnimation.pause();
                                // boxAnimation = null;
                            }
                        }, 500)
                    }
                });
            }
        });



        // 点击按钮执行以下方法
        this.elevatorButton.s('onDown', () => {
            // 按钮初始化
            this.buttonTearDown();
            // 按钮按下效果的状态
            let active = this.elevatorButton.a('active');
            // button为按钮集合数组，当按下电梯按钮，其他按钮默认false
            button.forEach(btn => {
                btn.a('active', false);
            });
            // 电梯按钮状态切换
            this.elevatorButton.a('active', !active);
            // 根据电梯按钮状态执行电梯运行或者切换回主视角
            if (active) {
                // 按钮控制
                this.parkingButton.s('2d.visible', true);
                this.coolingCentralStationButton.s('2d.visible', true);
                this.heatingCentralStationButton.s('2d.visible', true);
                this.floorNavigationButton.s('2d.visible', true);
                this.intelligentBuildingButton.s('2d.visible', true);
                // 切换回主视角
                moveCamera(g3d, [257.54842765918545, 713.7549555340285, 1485.9259185335227], [7, 40, 144], {
                    duration: 2000,
                    easing: t => t * t,
                    finishFunc: () => {
                        showNodeWithAll(this.coldStation);
                        showNodeWithAll(this.hotStation);
                        showNodeWithAll(this.unitStation);
                        this.building.eachChild(c => {
                            c.s({
                                'shape3d.transparent': false,
                            });
                        });
                        tweenColor(this.building_glass, 'wf.color', 'rgba(21,69,79,0.20)', 'rgba(55,65,66,1)', {
                            duration: 2000,
                            easing: t => t
                        });
                        tweenColor(this.building_glass, 'shape3d.blend', 'rgba(0,53,102,0.1)', 'rgba(0,53,102,1)', {
                            duration: 2000,
                            easing: t => t
                        });
                        tweenColor(this.building_box, 'wf.color', 'rgba(56,156,255,0.03)', 'rgba(72,149,232,1)', {
                            duration: 2000,
                            easing: t => t
                        });
                        tweenColor(this.building_box, 'shape3d.blend', 'rgba(120,180,255,0)', 'rgba(120,180,255,1)', {
                            duration: 2000,
                            easing: t => t,
                            finishFunc: () => {
                                // 隐藏电梯以及电梯线
                                hideNodeWithAll(this.elevator);
                                // 电梯销毁函数
                                this.elevatorList.forEach((data) => {
                                    this.elevatorTearDown(data);
                                });
                                // 楼层隐藏
                                this.floor.eachChild(c => {
                                    setNodeVisible(c, false);
                                });
                            }
                        });
                    }
                });
            } else {
                if (this.roamAnim !== null) {
                    this.roamAnim.pause();
                    this.roamAnim = null;
                }
                // 按钮控制
                this.parkingButton.s('2d.visible', false);
                this.coolingCentralStationButton.s('2d.visible', false);
                this.heatingCentralStationButton.s('2d.visible', false);
                this.floorNavigationButton.s('2d.visible', false);
                this.intelligentBuildingButton.s('2d.visible', false);
                // 切换到电梯视角
                elevatorAnimation = moveCamera(g3d, [-64.53572454038654, 167.68872616171888, 1143.1750195415216], [-124, 143, 219], {
                    duration: 2000,
                    easing: t => t * t,
                    finishFunc: () => {
                        // 隐藏冷站、热站和中央末端的场景
                        hideNodeWithAll(this.coldStation);
                        hideNodeWithAll(this.hotStation);
                        hideNodeWithAll(this.unitStation);
                        this.building.eachChild(c => {
                            c.s({
                                'shape3d.transparent': true,
                            });
                        });
                        tweenColor(this.building_glass, 'wf.color', 'rgba(55,65,66,1)', 'rgba(21,69,79,0.20)', {
                            duration: 2000,
                            easing: t => t
                        });
                        tweenColor(this.building_glass, 'shape3d.blend', 'rgba(0,53,102,1)', 'rgba(0,53,102,0.1)', {
                            duration: 2000,
                            easing: t => t,
                        });
                        tweenColor(this.building_box, 'wf.color', 'rgba(72,149,232,1)', 'rgba(56,156,255,0.03)', {
                            duration: 2000,
                            easing: t => t
                        });
                        tweenColor(this.building_box, 'shape3d.blend', 'rgba(120,180,255,1)', 'rgba(120,180,255,0)', {
                            duration: 2000,
                            easing: t => t,
                            finishFunc: () => {
                                // 展示电梯以及电梯线
                                showNodeWithAll(this.elevator);
                                // 执行电梯动画
                                this.elevatorList.forEach((data) => {
                                    this.elevatorAnimation1(data);
                                });
                                // 楼层显示
                                this.floor.eachChild(c => {
                                    setNodeVisible(c, true);
                                });
                            }
                        });
                    }
                });
            }
        });

        this.logo.s('onDown', () => {
            window.open('http://www.hightopo.com');
        });

        g3d.mi(this.handleInteractive, this);

        // g3d.mi(e => {
        //     const kind = e.kind;
        //     // 双击结点的事件处理
        //     if (kind === 'doubleClickData') {
        //         // 双击的结点
        //         let data = e.data;
        //         // 获取双击结点的标签
        //         let tag = data.getTag();
        //         if (!tag) return;
        //         // 如果结点标签为监控器
        //         if (tag === 'monitor') {
        //             // 监控面板显示
        //             this.intelligentMonitoring.s('2d.visible', true);
        //             // 载入本地资源视频流
        //             this.video.a('videoURL', './storage/assets/media/video.mp4');
        //         }
        //     }
        // });

        this.close.s('onDown', () => {
            this.intelligentMonitoring.s('2d.visible', false);
        })

    }

    showBuilding() {
        const g3dDm = this.g3dDm;
        // util.showPanel(this.lightingSystemPanel);
        showPanel(this.panel1);
        showPanel(this.panel2);
        showPanel(this.panel3);
        showPanel(this.panel4);
        showPanel(this.panel5);
        showPanel(this.panel6);
        showPanel(this.panel7);
        if (this.floorLighting === 1) {
            this.intelligentBuildingAnimation = tweenColor(this.floor1, 'shape3d.top.color','rgb(14,60,110)', 'rgb(124,145,155)', {
                duration : 300,
                easing : t => t,
                finishFunc: () => {
                    this.floorLighting = 2;
                    this.showBuilding();
                }
            });
        }
        if (this.floorLighting === 2) {
            this.intelligentBuildingAnimation = tweenColor(this.floor2, 'shape3d.top.color','rgb(14,60,110)', 'rgb(124,145,155)', {
                duration : 300,
                easing : t => t,
                finishFunc: () => {
                    this.floorLighting = 3;
                    this.showBuilding();
                }
            });
        }
        if (this.floorLighting === 3) {
            this.intelligentBuildingAnimation = tweenColor(this.floor3, 'shape3d.top.color','rgb(14,60,110)', 'rgb(124,145,155)', {
                duration : 300,
                easing : t => t,
                finishFunc: () => {
                    this.floorLighting = 4;
                    this.showBuilding();
                }
            });
        }
        if (this.floorLighting === 4) {
            this.intelligentBuildingAnimation = tweenColor(this.floor4, 'shape3d.top.color','rgb(14,60,110)', 'rgb(124,145,155)', {
                duration : 300,
                easing : t => t,
                finishFunc: () => {
                    this.floorLighting = 5;
                    this.showBuilding();
                }
            });
        }
        if (this.floorLighting === 5) {
            this.intelligentBuildingAnimation = tweenColor(this.floor5, 'shape3d.top.color','rgb(14,60,110)', 'rgb(124,145,155)', {
                duration : 300,
                easing : t => t,
                finishFunc: () => {
                    this.floorLighting = 6;
                    this.showBuilding();
                }
            });
        }
        if (this.floorLighting === 6) {
            this.intelligentBuildingAnimation = tweenColor(this.floor6, 'shape3d.top.color','rgb(14,60,110)', 'rgb(124,145,155)', {
                duration : 300,
                easing : t => t,
                finishFunc: () => {
                    this.floorLighting = 7;
                    this.showBuilding();
                }
            });
        }
        if (this.floorLighting === 7) {
            this.intelligentBuildingAnimation = tweenColor(this.floor7, 'shape3d.top.color','rgb(14,60,110)', 'rgb(124,145,155)', {
                duration : 300,
                easing : t => t,
                finishFunc: () => {
                    this.floorLighting = 8;
                    this.showBuilding();
                }
            });
        }
        if (this.floorLighting === 8) {
            this.intelligentBuildingAnimation = tweenColor(this.floor8, 'shape3d.top.color','rgb(14,60,110)', 'rgb(124,145,155)', {
                duration : 300,
                easing : t => t,
                finishFunc: () => {
                    this.floorLighting = 9;
                    this.showBuilding();
                }
            });
        }
        if (this.floorLighting === 9) {
            this.intelligentBuildingAnimation = tweenColor(this.floor9, 'shape3d.top.color','rgb(14,60,110)', 'rgb(124,145,155)', {
                duration : 300,
                easing : t => t,
                finishFunc: () => {
                    this.floorLighting = 10;
                    this.showBuilding();
                }
            });
        }
        if (this.floorLighting === 10) {
            this.intelligentBuildingAnimation = tweenColor(this.floor10, 'shape3d.top.color','rgb(14,60,110)', 'rgb(124,145,155)', {
                duration : 300,
                easing : t => t,
                finishFunc: () => {
                    // this.floorLighting = 11;
                    // this.showBuilding5();
                }
            });
        }
    }

    hideBuilding() {
        hidePanel(this.panel1);
        hidePanel(this.panel2);
        hidePanel(this.panel3);
        hidePanel(this.panel4);
        hidePanel(this.panel5);
        hidePanel(this.panel6);
        hidePanel(this.panel7);
        this.floor1.s('shape3d.top.color', 'rgb(14,60,110)');
        this.floor2.s('shape3d.top.color', 'rgb(14,60,110)');
        this.floor3.s('shape3d.top.color', 'rgb(14,60,110)');
        this.floor4.s('shape3d.top.color', 'rgb(14,60,110)');
        this.floor5.s('shape3d.top.color', 'rgb(14,60,110)');
        this.floor6.s('shape3d.top.color', 'rgb(14,60,110)');
        this.floor7.s('shape3d.top.color', 'rgb(14,60,110)');
        this.floor8.s('shape3d.top.color', 'rgb(14,60,110)');
        this.floor9.s('shape3d.top.color', 'rgb(14,60,110)');
        this.floor10.s('shape3d.top.color', 'rgb(14,60,110)');
    }

    handleInteractive(e) {
        const kind = e.kind;
        if (kind === 'doubleClickData') {
            let data = e.data;
            let tag = data.getTag();
            if (!tag) return;
            if (tag === 'monitor') {
                this.intelligentMonitoring.s('2d.visible', true);
                this.close.s('2d.visible', true);
                this.video.a('videoURL', './storage/assets/media/video.mp4');
            }
        }
    }

    elevatorAnimation1(data) {
        const g3d = this.g3d;
        const tag = data.getTag();
        const e = data.getElevation();
        const label = data.getChildAt(0);
        // 判断现在所处楼层
        let now = Math.ceil(e / 50);
        // 下一层楼层取1~10随机数
        let next = randomNumber(1, 7);
        // 根据现在的楼层和下一个楼层，判断电梯运行的范围
        let range = numBetween(now, next);
        this.animationElevatorMap[tag] = ht.Default.startAnim({
            duration: range * 800,
            easing: t => t,
            action: (v, t) => {
                // 电梯运行位置设定
                data.setElevation(now < next ? (e + (range * 50) * v) : (e - (range * 50) * v));
                // 设置电梯楼层面板显示并根据电梯位置设定
                if (!label) return;
                const f = Math.ceil(data.getElevation() / 50);
                if (f === label.a('text')) return;
                label.a('text', f + 3);
                // 手动刷新电梯面板信息
                g3d.invalidateShape3dCachedImage(label);
            },
            finishFunc: () => {
                // if (!this.running) return;

                // 销毁电梯间隔动画
                delete this.timeoutElevatorMap[tag];

                // 执行电梯间隔动画后回调电梯运行动画
                this.timeoutElevatorMap[tag] = setTimeout(() => {
                    this.elevatorAnimation1(data);
                }, Math.floor(Math.random() * 5000) + 2000);
            }
        });
    }

    elevatorTearDown() {
        // this.running = false;

        // 电梯运行动画暂停并清空
        for (let tag in this.animationElevatorMap)
            this.animationElevatorMap[tag].stop();
        this.animationElevatorMap = {};

        // 电梯间隔调度移除
        for (let k in this.timeoutElevatorMap)
            clearTimeout(this.timeoutElevatorMap[k]);
        this.timeoutElevatorMap = {};

        // 设置电梯默认位置
        this.elevatorList.forEach((data) => {
            data.setElevation(0)
        });
    }

    buttonTearDown() {
        if (this.coolingCentralStationAnimation !== null) {
            this.coolingCentralStationAnimation.pause();
            this.coolingCentralStationAnimation = null;
        }
        if (this.heatingCentralStationAnimation !== null) {
            this.heatingCentralStationAnimation.pause();
            this.heatingCentralStationAnimation = null;
        }
        if (this.floorNavigationAnimation !== null) {
            this.floorNavigationAnimation.pause();
            this.floorNavigationAnimation = null;
        }
        if (this.elevatorAnimation !== null) {
            this.elevatorAnimation.pause();
            this.elevatorAnimation = null;
        }
    }

    /**
     * @description 三维场景加载完成后的处理操作
     * @memberof App
     */
    loaded3DHandler() {
        const g3d = this.g3d;
        const g3dDm = this.g3dDm;

        g3d.mi(e => {
            const data = e.data;
            const kind = e.kind;
            // console.log(e.kind);

        });
    }

    parkingTearDown(view) {
        if (this.getDataAtFunc)
            view.getDataAt = this.getDataAtFunc;

        if (this.getDataInfoAtFunc)
            view.getDataInfoAt = this.getDataInfoAtFunc;

        // 这边使用 pause 而不使用 stop，是因为 stop 会执行 finishFunc，可能导致又启动一个动画
        for (let tag in this.animationMap) {
            this.animationMap[tag].pause();
        }
        this.animationMap = {};

        for (let k in this.timeoutMap)
            clearTimeout(this.timeoutMap[k]);
        this.timeoutMap = {};

        if (this.loopAnimation) {
            this.loopAnimation.stop();
            this.loopAnimation = null;
        }

        this.updateLight(view, this.light1, 'green');
        this.updateLight(view, this.light2, 'red');
        this.updateLight(view, this.light3, 'green');
    }

    parkingSetup(view) {
        this.getDataAtFunc = view.getDataAt;
        view.getDataAt = () => {
        };

        this.getDataInfoAtFunc = view.getDataInfoAt;
        view.getDataInfoAt = () => {
        };

        this.loopAnimation = loop(() => {
            for (let k in this.arrowMap) {
                const list = this.arrowMap[k];
                const len = list.length;
                if (k === 'left') {
                    for (let l = 0; l < len; l++) {
                        const lData = list[l];
                        const x = lData.getAnchorX();
                        if (x > 0.6) lData.setAnchorX(0);
                        else lData.setAnchorX(x + 0.02);
                    }
                } else if (k === 'right') {
                    for (let r = 0; r < len; r++) {
                        const rData = list[r];
                        const x = rData.getAnchorX();
                        if (x < 0.4) rData.setAnchorX(1);
                        else rData.setAnchorX(x - 0.02);
                    }
                } else if (k === 'front') {
                    for (let f = 0; f < len; f++) {
                        const fData = list[f];
                        const e = fData.getAnchorElevation();
                        if (e < 0.4) fData.setAnchorElevation(1);
                        else fData.setAnchorElevation(e - 0.02);
                    }
                }
            }
        });

        this.restart(view);
    }

    restart(view) {
        if (this.restartStatus === 0) {
            this.car1Anim(view);

            this.car2Anim(view);

            this.car3Anim(view);
        }
        this.restartStatus = (this.restartStatus + 1) % 3;
    }

    car1Anim(view) {
        setNodeVisible(this.car1, true);

        this.park(this.car1, undefined, () => {
            this.updateLight(view, this.light1, 'red');

            for (let i = 0; i < 2; i++)
                this.updatePanel(view, this.panelList.getChildAt(i), {front: -1});

            this.updatePanel(view, this.panelList.getChildAt(2), {left: -1});

            this.timeoutMap['car1'] = setTimeout(() => {
                delete this.timeoutMap['car1'];

                this.updateLight(view, this.light1, 'green');

                for (let i = 0; i < 2; i++)
                    this.updatePanel(view, this.panelList.getChildAt(i), {front: 1});

                this.updatePanel(view, this.panelList.getChildAt(2), {left: 1});

                this.leave(this.car1, () => {
                    setNodeVisible(this.car1, false);

                    this.timeoutMap['car1'] = setTimeout(() => {
                        delete this.timeoutMap['car1'];

                        this.restart(view);
                    }, 10000);
                });
            }, 8000);
        });
    }

    car2Anim(view) {
        this.updateLight(view, this.light2, 'green');

        for (let i = 0; i < 2; i++)
            this.updatePanel(view, this.panelList.getChildAt(i), {front: 1});

        this.updatePanel(view, this.panelList.getChildAt(2), {left: 1});

        this.park(this.car2, undefined, () => {
            this.updateLight(view, this.light3, 'red');

            for (let i = 0; i < 6; i++)
                this.updatePanel(view, this.panelList.getChildAt(i), {front: -1});

            this.updatePanel(view, this.panelList.getChildAt(6), {left: -1});

            this.timeoutMap['car2'] = setTimeout(() => {
                delete this.timeoutMap['car2'];

                this.updateLight(view, this.light3, 'green');

                for (let i = 0; i < 6; i++)
                    this.updatePanel(view, this.panelList.getChildAt(i), {front: 1});

                this.updatePanel(view, this.panelList.getChildAt(6), {left: 1});

                this.leave(this.car2, () => {
                    setNodeVisible(this.car2, false);

                    this.timeoutMap['car2'] = setTimeout(() => {
                        delete this.timeoutMap['car2'];

                        setNodeVisible(this.car2, true);

                        this.park(this.car2, 'Path2', () => {
                            for (let i = 0; i < 2; i++)
                                this.updatePanel(view, this.panelList.getChildAt(i), {front: -1});

                            this.updatePanel(view, this.panelList.getChildAt(2), {left: -1});

                            this.updateLight(view, this.light2, 'red');

                            this.timeoutMap['car2'] = setTimeout(() => {
                                delete this.timeoutMap['car2'];

                                this.restart(view);
                            }, 3000);
                        });
                    }, 3000);
                });
            }, 3000);
        });
    }

    car3Anim(view) {
        this.updateLight(view, this.light4, 'green');

        for (let i = 0; i < 4; i++)
            this.updatePanel(view, this.panelList.getChildAt(i), {front: 1});

        this.updatePanel(view, this.panelList.getChildAt(4), {left: 1});

        this.leave(this.car3, () => {
            setNodeVisible(this.car3, false);

            this.timeoutMap['car3'] = setTimeout(() => {
                delete this.timeoutMap['car3'];

                setNodeVisible(this.car3, true);

                this.park(this.car3, undefined, () => {

                    for (let i = 0; i < 4; i++)
                        this.updatePanel(view, this.panelList.getChildAt(i), {front: -1});

                    this.updatePanel(view, this.panelList.getChildAt(4), {left: -1});

                    this.updateLight(view, this.light4, 'red');

                    this.timeoutMap['car3'] = setTimeout(() => {
                        delete this.timeoutMap['car3'];

                        this.restart(view);
                    }, 9000);
                });
            }, 8000);
        });
    }

    park(car, key = 'Path', finishFunc) {
        const dm = car.dm();
        const tag = car.getTag();
        const forwardPath = dm.getDataByTag(tag + '_forward' + key);
        const backwardPath = dm.getDataByTag(tag + '_backward' + key);
        this.animationMap[tag] = move(car, forwardPath, 'forward', undefined, 24, {
            pathEndFunc: () => {
                this.animationMap[tag].stop();

                this.animationMap[tag] = move(car, backwardPath, 'backward', undefined, undefined, {
                    pathEndFunc: () => {
                        this.animationMap[tag].stop();
                        delete this.animationMap[tag];

                        if (finishFunc) finishFunc();
                        return true;
                    }
                });
                return true;
            }
        });
    }

    leave(car, finishFunc) {
        const dm = car.dm();
        const tag = car.getTag();
        const path = dm.getDataByTag(tag + '_leave');
        this.animationMap[tag] = move(car, path, 'forward', undefined, 24, {
            pathEndFunc: () => {
                this.animationMap[tag].stop();
                delete this.animationMap[tag];

                if (finishFunc) finishFunc();

                return true;
            }
        });
    }

    updatePanel(view, panel, data) {
        let v;
        for (let k in data) {
            v = parseInt(panel.a(k + 'Parking'));
            v = v + data[k];
            panel.a(k + 'Parking', v);

            panel.a(k + 'TextColor', v === 0 ? 'rgb(140, 0, 0)' : undefined);

            let arrow;
            panel.eachChild(d => {
                if (d.getDisplayName() === k)
                    arrow = d;
            });
            arrow.a('color', v === 0 ? 'rgb(255, 0, 0)' : undefined);
            view.invalidateShape3dCachedImage(arrow);
        }
        view.invalidateShape3dCachedImage(panel);
    }

    updateLight(view, light, color) {
        light.s('shape3d.image', 'symbols/parking/' + color + 'Light.json');
        view.invalidateShape3dCachedImage(light);
    }


    /**
     * @description 加载场景到 DOM 节点
     * @param {String||Object} parentNode
     * @memberof App
     */
    addToDOM(parentNode) {
        const g3d = this.g3d;
        // this.g2d.addToDOM();
        parentNode ? (typeof parentNode === 'string' ? g3d.addToDOM(document.getElementById(parentNode)) : g3d.addToDOM(parentNode)) : g3d.addToDOM();
    }

}

